import { useTranslation } from "next-i18next";
import React from "react";

import type { UI_CONTEXT } from "@/analytics/constants";

import { DropdownMenuItem } from "@/components/dropdown-menus/dropdown-menu-items/dropdown-menu-item-interface";

import { Locale } from "@/types/locale";

import { ControlFilters } from "../control-filters/control-filters-search";
import styles from "./controlHeader.module.scss";

export interface Props {
    locale: Locale;
    uiContext: UI_CONTEXT;
    searchVersion: string;
    searchTerm: string;
    storeCount: number;
    hasOffers: boolean;
    sortByOptions: Array<DropdownMenuItem>;
    handleOffersClick: () => void;
    handleSortByClick: (sortByValue: string) => void;
}

const ResultDetails = ({ resultCount, searchTerm }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.controlHeaderResultCountContainer}>
            <span className={styles.controlHeaderResultCount}>
                {resultCount} {t("store.searchResultCountText")}
            </span>{" "}
            <span data-testid="search-result">
                {t("store.searchResultCountForText")} {searchTerm}
            </span>
        </div>
    );
};

export const ControlHeader: React.FC<Props> = (props) => {
    const {
        locale,
        hasOffers,
        handleOffersClick,
        handleSortByClick,
        uiContext,
        searchVersion,
        searchTerm,
        storeCount,
        sortByOptions,
    } = props;

    return (
        <div className={styles.controlHeaderContainerSearch}>
            <ResultDetails resultCount={storeCount} searchTerm={searchTerm} />
            <ControlFilters
                locale={locale}
                hasOffers={hasOffers}
                handleOffersClick={handleOffersClick}
                handleSortByClick={handleSortByClick}
                sortByOptions={sortByOptions}
                uiContext={uiContext}
                searchVersion={searchVersion}
                searchTerm={searchTerm}
                storeCount={storeCount}
            />
        </div>
    );
};
